export const data = {
      maps: [
        {
          name: 'Comelico',
          width: 1069,
          height: 591,
          id: '1',
          image: 'http://test.variant.design/siriobluevision/wp-content/themes/siriobluevision/app/www/img/map1.jpg'
        },
        {
          name: 'Comelico est',
          width: 1069,
          height: 591,
          id: '2',
          image: 'http://test.variant.design/siriobluevision/wp-content/themes/siriobluevision/app/www/img/map2.jpg'
        },
        {
          name: 'Comelico ovest',
          width: 1069,
          height: 591,
          id: '3',
          image: 'http://test.variant.design/siriobluevision/wp-content/themes/siriobluevision/app/www/img/map3.jpg'
        }
      ],
      places: [
        {
          label: 'tables',
          name: 'Legende',
          items: [
            { id: '1', name: 'Stradario 1', type: 'table',
              image: 'http://test.variant.design/siriobluevision/wp-content/themes/siriobluevision/app/www/img/legenda.png'
            },
            { id: '2', name: 'Stradario 2', type: 'table',
              image: 'http://test.variant.design/siriobluevision/wp-content/themes/siriobluevision/app/www/img/legenda.png'
            },
          ]
        },
        {
          label: 'shopping',
          name: 'Attività commerciali',
          items: [
            { id: '1', name: 'Tabaccheria Corso', map: '1', x: '24', y: '34', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '2', name: 'Pescheria Maurizio', map: '1', x: '44', y: '44', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '3', name: 'Abbigliamento kappa', map: '1', x: '54', y: '84', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '4', name: 'Elettrodomestici', map: '1', x: '64', y: '52', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '5', name: 'Tabaccheria Corso', map: '1', x: '74', y: '62', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '6', name: 'Abbigliamento kappa', map: '1', x: '12', y: '63', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '7', name: 'Caccia e pesca da Giorgio', map: '1', x: '10', y: '65', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '8', name: 'Tabaccheria Cortina', map: '2', x: '80', y: '54', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '9', name: 'Fashion Industry', map: '1', x: '28', y: '64', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '10', name: 'Tabaccheria Corso', map: '1', x: '38', y: '65', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '11', name: 'Pescheria Cortina', map: '2', x: '33', y: '75', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '12', name: 'Tabaccheria Corso', map: '1', x: '12', y: '80', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            }
          ]
        },
        {
          label: 'sport',
          name: 'Sport e cultura',
          items: [
            { id: '1', name: 'Tabaccheria Corso', map: '1', x: '24', y: '34', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '2', name: 'Pescheria Maurizio', map: '1', x: '44', y: '44', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '3', name: 'Abbigliamento kappa', map: '2', x: '54', y: '84', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '4', name: 'Elettrodomestici', map: '1', x: '64', y: '62', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '5', name: 'Tabaccheria Corso', map: '2', x: '74', y: '52', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '6', name: 'Abbigliamento kappa', map: '2', x: '12', y: '63', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '7', name: 'Caccia e pesca da Giorgio', map: '1', x: '10', y: '65', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '8', name: 'Tabaccheria Cortina', map: '2', x: '80', y: '54', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '9', name: 'Fashion Industry', map: '1', x: '28', y: '64', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '10', name: 'Tabaccheria Corso', map: '1', x: '38', y: '65', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '11', name: 'Pescheria Cortina', map: '1', x: '33', y: '75', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '12', name: 'Tabaccheria Corso', map: '1', x: '12', y: '80', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            }
          ]
        },
        {
          label: 'hotel',
          name: 'Dove dormire',
          items: [
            { id: '1', name: 'Tabaccheria Corso', map: '1', x: '24', y: '34', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '2', name: 'Pescheria Maurizio', map: '1', x: '44', y: '44', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '3', name: 'Abbigliamento kappa', map: '2', x: '54', y: '84', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '4', name: 'Elettrodomestici', map: '1', x: '64', y: '52', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '5', name: 'Tabaccheria Corso', map: '2', x: '74', y: '12', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '6', name: 'Abbigliamento kappa', map: '2', x: '12', y: '53', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '7', name: 'Caccia e pesca da Giorgio', map: '1', x: '10', y: '55', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '8', name: 'Tabaccheria Cortina', map: '2', x: '80', y: '54', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '9', name: 'Fashion Industry', map: '1', x: '28', y: '64', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '10', name: 'Tabaccheria Corso', map: '1', x: '38', y: '65', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '11', name: 'Pescheria Cortina', map: '1', x: '33', y: '75', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '12', name: 'Tabaccheria Corso', map: '1', x: '12', y: '80', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            }
          ]
        },
        {
          label: 'eat',
          name: 'Dove mangiare',
          items: [
            { id: '1', name: 'Tabaccheria Corso', map: '1', x: '24', y: '54', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '2', name: 'Pescheria Maurizio', map: '1', x: '44', y: '44', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '3', name: 'Abbigliamento kappa', map: '1', x: '54', y: '84', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '4', name: 'Elettrodomestici', map: '1', x: '64', y: '52', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '5', name: 'Tabaccheria Corso', map: '1', x: '74', y: '62', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '6', name: 'Abbigliamento kappa', map: '1', x: '12', y: '63', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '7', name: 'Caccia e pesca da Giorgio', map: '1', x: '10', y: '55', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '8', name: 'Tabaccheria Cortina', map: '2', x: '80', y: '54', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '9', name: 'Fashion Industry', map: '1', x: '28', y: '64', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '10', name: 'Tabaccheria Corso', map: '1', x: '38', y: '65', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '11', name: 'Pescheria Cortina', map: '2', x: '33', y: '75', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            },
            { id: '12', name: 'Tabaccheria Corso', map: '1', x: '12', y: '80', 
              description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation',
              image: 'http://lorempixel.com/1200/800/food',
              website: 'http://www.google.com'
            }
          ]
        },
        {
          label: 'path',
          name: 'Piste da sci',
          items: [
            { id: '1', name: 'R45', map: '1', x: '24', y: '44', x2: '44', y2: '71', type: 'path'},
            { id: '2', name: 'R46', map: '2', x: '34', y: '43', x2: '54', y2: '72', type: 'path'},
            { id: '3', name: 'R47', map: '1', x: '44', y: '42', x2: '64', y2: '73', type: 'path'},
            { id: '4', name: 'R48', map: '3', x: '54', y: '41', x2: '74', y2: '74', type: 'path'},

          ]
        }
      ]
    }



// WEBPACK FOOTER //
// ./src/data.js